import { HttpClient } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, retry, timeout, timer } from 'rxjs';

import {
  PaymentHistoryResponse,
  PaymentPlan,
  RazorpayPaymentResponse,
  VerifyPaymentResponse,
} from './payments.models';

@Injectable({ providedIn: 'root' })
export class PaymentsApiService {
  private readonly http = inject(HttpClient);

  listPlans(): Observable<PaymentPlan[]> {
    return this.http
      .get<PaymentPlan[]>('/api/payments/plans', { withCredentials: true })
      .pipe(timeout(15_000));
  }

  createCheckoutOptions(plan: PaymentPlan): Observable<Record<string, unknown>> {
    return this.http
      .post<Record<string, unknown>>('/options', plan, { withCredentials: true })
      .pipe(timeout(15_000));
  }

  verifyRazorpayPayment(resp: RazorpayPaymentResponse): Observable<VerifyPaymentResponse> {
    return this.http
      .post<VerifyPaymentResponse>('/payment_info', resp, { withCredentials: true })
      .pipe(
        timeout(30_000),
        retry({
          count: 3,
          delay: (_error, retryCount) =>
            timer(Math.min(1000 * 2 ** retryCount, 8000) + Math.random() * 500),
        }),
      );
  }

  getPaymentHistory(skip: number, limit: number): Observable<PaymentHistoryResponse> {
    return this.http
      .get<PaymentHistoryResponse>('/payment-history', {
        params: { skip, limit },
        withCredentials: true,
      })
      .pipe(timeout(15_000));
  }

  downloadInvoice(id: string): Observable<HttpResponse<Blob>> {
    return this.http
      .get(`/invoices/${encodeURIComponent(id)}/download`, {
        observe: 'response',
        responseType: 'blob',
        withCredentials: true,
      })
      .pipe(timeout(30_000));
  }
}
